import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { KoffiState, VoiceRobotComponent } from '../voice-robot/voice-robot.component';

/**
 * Mascotte affichée au-dessus des actions rapides, sur une conversation vide
 * (MOKA-208). Depuis la charte café (MOKA-214), c'est la mascotte en 3D, la tasse
 * de café, qui change de pose selon ce que fait l'assistant.
 *
 * Mouvements volontairement lents et de faible amplitude : l'écran vide doit
 * paraître vivant, pas réclamer l'attention pendant qu'on lit les actions.
 * Tout est en CSS, donc suspendu par `prefers-reduced-motion`.
 */
@Component({
  selector: 'app-voice-assistant-avatar',
  standalone: true,
  imports: [VoiceRobotComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './voice-assistant-avatar.component.html',
  styleUrl: './voice-assistant-avatar.component.scss'
})
export class VoiceAssistantAvatarComponent {
  /** Message affiché dans la bulle, à côté de la mascotte. */
  greeting = input.required<string>();

  /** Ce que fait l'assistant (écoute, réflexion, parole) : choisit la pose. */
  state = input<KoffiState>('repos');
}
